import { reportError } from '../sentry';

export function copyJournalText(
  containerId: string = 'journal-copy-content'
): Promise<boolean> {
  const mainContent = document.querySelector(`#${containerId}`);
  if (!mainContent) return Promise.resolve(false);

  const elements = Array.from(mainContent.querySelectorAll('h2, p, span'));

  const textContent = elements
    .map((el) => {
      if (el.tagName.toLowerCase() === 'h2') {
        return `\n${el.textContent?.trim().toUpperCase()}`;
      }
      return el.textContent?.trim();
    })
    .filter((text) => text && text !== '')
    .join('\n');

  return navigator.clipboard
    .writeText(textContent)
    .then(() => true)
    .catch((err) => {
      reportError(err, { level: 'warning', tags: { area: 'clipboard' } });
      return false;
    });
}
